'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useLocale as useNextIntlLocale } from 'next-intl';
import { toBackendLocale } from '@/lib/utils';

/**
 * Custom hook that returns both URL locale (lowercase) and backend locale (e.g., en-US).
 *
 * @returns {{ locale: string, backendLocale: string }} The URL locale and backend locale.
 */
export const useAppLocale = () => {
  const $ = _c(5);
  const locale = useNextIntlLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = toBackendLocale(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const backendLocale = t0;
  let t1;
  if ($[2] !== backendLocale || $[3] !== locale) {
    t1 = {
      locale,
      backendLocale
    };
    $[2] = backendLocale;
    $[3] = locale;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default useAppLocale;